<!-- If not Insights Data point Column -->
<span *ngIf = " !isDataPointClick " >
	<div class="FunnelCols" id ="FunnelCount" *ngIf ="! showSimpleColumn" >
		<span class="SpanCount"  > {{eventNumber}} </span> 
		<span class="SpanPercnt" >  {{eventPercentage}} </span> 
	</div>
	<div *ngIf = "showPercentStatus && ! showSimpleColumn "  class="FunnelCols">
		<span class="{{percentCompareClass}} " > {{percentCompareValue}} </span>	
	</div>
</span>

<span *ngIf = " !isDataPointClick && showSimpleColumn" > {{showSimpleColumnVal}} </span>


<!-- If Insights Data point Column  -->

<span *ngIf = "isDataPointClick"  (click) = "onClick( )" >
	<div class="FunnelCols insight-data-point" id ="FunnelCount" *ngIf ="! showSimpleColumn" >
		<span class="SpanCount" style="color: #143F93 !important;" > {{eventNumber}} </span> 
		<span class="SpanPercnt" style="color: #143F93 !important;">  {{eventPercentage}} </span> 
	</div>
	<div *ngIf = "showPercentStatus && ! showSimpleColumn "  class="FunnelCols">
		<span class="{{percentCompareClass}} " style="color: #143F93 !important;"> {{percentCompareValue}} </span>	
	</div>
</span>

<span *ngIf = "isDataPointClick && showSimpleColumn" style="color: #143F93 !important;" class="insight-data-point" (click) = "onClick( )" > {{showSimpleColumnVal}} </span>







